<div class="table-container">
  <ng-container *ngIf="results?.length; else emptyTpl">
    <app-scroll-view
      class="scroll-view"
      [vertical]="true"
      [horizontal]="true"
      [appBlockModalDrag]="!(isMobileObservable | async)"
    >
      <table
        class="table-results"
        [ngClass]="{ mobile: isMobileObservable | async }"
        mat-table
        [dataSource]="results"
        [multiTemplateDataRows]="true"
      >
        <ng-container
          matColumnDef="{{ column.name }}"
          *ngFor="let column of columns"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-cell"
            style="--width: {{ column.width }};--min-width: {{
              column.minWidth
            }};text-align: {{ column.align || 'left' }}"
          >
            {{ getAlias(column) }}
          </th>

          <td
            mat-cell
            *matCellDef="let item"
            class="table-cell"
            style="--width: {{ column.width }};--min-width: {{
              column.minWidth
            }};text-align: {{ column.align || 'left' }}"
            title="{{ item?.[column.name] }}"
          >
            {{ item?.[column.name] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandControl">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-cell expandControl"
          ></th>

          <td mat-cell *matCellDef="let item" class="table-cell">
            <app-iconic
              *ngIf="isExpandable(item)"
              icon="assets/icons/chevron-down.svg"
            ></app-iconic>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let item"
            class="expandedDetailColumn"
            [attr.colspan]="displayedColumns.length"
          >
            <ng-template
              *ngIf="isExpanded(item)"
              [ngTemplateOutlet]="nestedTpl"
              [ngTemplateOutletContext]="{item}"
            ></ng-template>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="table-header"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row"
          [ngClass]="{ 'visibility-collapse': isExpanded(row) }"
          (click)="onRowClick(row)"
        ></tr>

        <tr
          mat-row
          *matRowDef="
            let row;
            columns: ['expandedDetail'];
            when: whenExpandable
          "
          [hidden]="!isExpanded(row)"
          class="expandedDetailRow"
        ></tr>
      </table>
    </app-scroll-view>
  </ng-container>

  <ng-template #emptyTpl>
    <div class="empty-results">{{ noDataText }}</div>
  </ng-template>
</div>

<ng-template #nestedTpl let-item="item">
  <div class="nested-container" (click)="toggleExpand(item)">
    <app-scroll-view class="scroll-view" [vertical]="false" [horizontal]="true">
      <table
        class="table-results"
        mat-table
        [dataSource]="getChildren(item)"
        [ngClass]="{ mobile: isMobileObservable | async }"
      >
        <ng-container
          matColumnDef="{{ column.name }}"
          *ngFor="let column of columns; let i = index"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-cell"
            [ngClass]="{ 'adapt-mode': i === columns.length - 1 }"
            style="--width: {{ column.width }};--min-width: {{
              column.minWidth
            }};text-align: {{ column.align || 'left' }}"
          ></th>

          <td
            mat-cell
            *matCellDef="let subItem"
            class="table-cell"
            style="--width: {{ column.width }};--min-width: {{
              column.minWidth
            }};text-align: {{ column.align || 'left' }}"
            title="{{ i === 0 && getIndexInChildren(item, subItem) !== 0 ? '' : subItem?.[column.name] }}"
          >
            {{ i === 0 && getIndexInChildren(item, subItem) !== 0 ? '' : subItem?.[column.name] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandControl">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-cell expandControl"
          ></th>

          <td mat-cell *matCellDef="let subItem; let index" class="table-cell">
            <app-iconic
              *ngIf="getIndexInChildren(item, subItem) === 0"
              class="rotate-180"
              icon="assets/icons/chevron-down.svg"
            ></app-iconic>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="table-header"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row"
          (click)="onRowClick(row)"
        ></tr>
      </table>
    </app-scroll-view>
  </div>
</ng-template>
